import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useWarehouseShippingMethodsTable } from 'src/pages/settings/admin/warehouseShippingMethods/useWarehouseShippingMethodsTable';

export const WarehouseShippingMethodsTablePage = () => {
    const [columns, tableSettings] = useWarehouseShippingMethodsTable();
    return (
        <>
            <PageHeader {...{
                title: "Warehouse Shipping Methods", subTitle: "View shipping methods for shipping between warehouses",
                components: generateTablePageButtons(tableSettings),
            }} />
            <ContentCardsContainer>
                <ContentCard cardId="Warehouse Shipping Methods" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default WarehouseShippingMethodsTablePage;
